import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { FormProvider, useForm } from 'react-hook-form';
import { FormFieldArticleType } from '@publishing-engine/domain/types/article';
import { ArticleTypeSelect } from './ArticleTypeSelect';
import { IChangeArticleType } from '@publishing-engine/domain/models';
import { useQuery } from '@tanstack/react-query';
import { fetchArticleTypesCompatibility } from '../../../../api/queries';

interface IProps {
  isOpen: boolean;
  onSubmit: (value: IChangeArticleType) => void;
  onCancel: () => void;
  formField: FormFieldArticleType;
  value: string;
  submissionId: string;
}

const SelectUpdateModal: React.FC<IProps> = props => {
  const { isOpen, onSubmit, onCancel, formField, submissionId, value } = props;

  const methods = useForm({
    defaultValues: {
      newName: value
    }
  });

  const { data, isLoading } = useQuery({
    queryKey: ['article-types-compatibility', submissionId],
    queryFn: () => fetchArticleTypesCompatibility(submissionId)
  });

  const handleSubmit = ({ newName }: Pick<IChangeArticleType, 'newName'>) => {
    const newTypeId = data?.find(a => a.name === newName)?.articleWorkflowId!;
    onSubmit({
      newName,
      newTypeId
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        gap={8}
        bgColor="surfacePrimaryFill"
        flexDirection="column"
        borderRadius="base"
      >
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            <Flex
              padding={8}
              gap={6}
              bgColor="surfacePrimaryFill"
              flexDirection="column"
              borderRadius="base"
            >
              <Flex maxHeight={700} overflow={'auto'}>
                <ArticleTypeSelect
                  config={formField}
                  isLoadingOptions={isLoading}
                  options={data || []}
                />
              </Flex>
              <Flex
                gap={2}
                justifyContent="flex-end"
                alignItems="center"
                alignSelf="stretch"
              >
                <Button
                  variant="secondary"
                  onClick={onCancel}
                  borderRadius="small"
                >
                  Exit Without Saving
                </Button>
                <Button
                  disabled={isLoading}
                  variant="primary"
                  type="submit"
                  borderRadius="small"
                >
                  Save Changes
                </Button>
              </Flex>
            </Flex>
          </form>
        </FormProvider>
      </Flex>
    </Modal>
  );
};

export default SelectUpdateModal;
